export const ASSETS = {
  "logos": {
    "splash_logo": {
      "path": "https://ucarecdn.com/9b085650-299a-443a-8578-c81a29356513/graph.png",
      "height": 300,
      "width": 300
    }
  },
  "music": {
    "main_theme": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1d7778331fe64ae4a5489aaf2a598c38/1740a41bb7174b9986eed5077f73d53d/preview/assets/music/calm-and-peaceful.mp3",
      "height": 300,
      "width": 300
    }
  },
  "sfx": {
    "combination_fail": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1d7778331fe64ae4a5489aaf2a598c38/6c15373ba081445a8f8447ae0d7054d1/preview/assets/sfx/combination-fail.ogg",
      "volume": 0.4
    },
    "combination_pair": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1d7778331fe64ae4a5489aaf2a598c38/6c15373ba081445a8f8447ae0d7054d1/preview/assets/sfx/combination-pair.ogg",
      "volume": 0.6
    },
    "combination_triple": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1d7778331fe64ae4a5489aaf2a598c38/6c15373ba081445a8f8447ae0d7054d1/preview/assets/sfx/combination-triple.ogg",
      "volume": 0.8
    },
    "serving_drop": {
      "path": "https://ucarecdn.com/3de66a0c-1649-4170-bce1-760a3de2f04f/bell_01.ogg",
      "height": 300,
      "width": 300
    },
    "settings_test": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1d7778331fe64ae4a5489aaf2a598c38/61595f3bbb8e4289a6a93dc31cc11f7b/preview/assets/sfx/settings-test.ogg",
      "volume": 0.5
    }
  },
  "ui": {
    "background": {
      "path": "https://ucarecdn.com/b41a6332-76ec-4703-83c0-53ca07e7d056/food_craft2_bg.png",
      "height": 300,
      "width": 300
    },
    "ingame_button": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1d7778331fe64ae4a5489aaf2a598c38/4b455205acef46aea4ca8dd6e76e813e/preview/assets/ui/ingame-button.png",
      "height": 44,
      "width": 140
    },
    "ingame_button_hover": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1d7778331fe64ae4a5489aaf2a598c38/4b455205acef46aea4ca8dd6e76e813e/preview/assets/ui/ingame-button-hover.png",
      "height": 44,
      "width": 140
    },
    "loading_spinner": {
      "path": "https://ucarecdn.com/5e97d6b5-3540-45bb-97cc-88820ecc2083/pan_emoji.png",
      "height": 96,
      "width": 96
    },
    "play_button": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/96cfd87e18dc4acdbea18cef49c90d2a/main/preview/assets/ui/button_primary.svg",
      "height": 60,
      "width": 200
    },
    "play_button_hover": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/96cfd87e18dc4acdbea18cef49c90d2a/main/preview/assets/ui/button_primary.svg",
      "height": 60,
      "width": 200
    },
    "settings_button": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/96cfd87e18dc4acdbea18cef49c90d2a/main/preview/assets/ui/button_primary.svg",
      "height": 50,
      "width": 160
    },
    "settings_button_hover": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/96cfd87e18dc4acdbea18cef49c90d2a/main/preview/assets/ui/button_primary.svg",
      "height": 50,
      "width": 160
    },
    "title_background": {
      "path": "https://ucarecdn.com/6630e842-55ec-4283-8a48-62c920961416/food_craft_bg.png",
      "height": 300,
      "width": 300
    }
  }
};
